<template>
  <div id="pay">
    <div class="con">
      <div class="tabcon2">
        <div class="t2_tt">
          <span>请您核对本次消费金额</span>
        </div>
        <ul>
          <li class="displayflex">
            <span class="li1">账单金额：</span>
            <div class="li2">
              <div><span>{{orderAmount}}</span>元</div>
            </div>
          </li>
          <li class="displayflex">
            <span class="li1">账单折扣：</span>
            <div  class="li2"><div><span class="color-red">{{discount}}</span>元</div></div>
            <!--<span class="li3">优惠类型：会员价</span>-->
          </li>

          <li class="displayflex">
            <span class="li1">优惠券抵扣：</span>
            <div  class="li2">
              <div><span class="color-red">{{fentoyuan(yhjdk_money)==0?0:'- '+fentoyuan(yhjdk_money)}}</span>元</div>
              <div class="color-gray" v-if="couponsItem.typename && canuseyhj()">已选{{couponsItem.typename}}</div>
            </div>
            <div class="li3" v-if="couponList.length > 0 ">
              <van-button @click="showdialog2">可使用({{couponList.length}})</van-button>
            </div>
          </li>

          <li class="displayflex">
            <span class="li1">应付金额：</span>
            <div  class="li2"><div><span>{{lastAmount}}</span>元</div></div>
          </li>

          <li class="displayflex" v-if="vip.isVip==1">
            <span class="li1">账户余额：</span>
            <div  class="li2"><div><span class="color-blue">{{vip.balance}}</span>元</div></div>
            <div class="li3" >
              <van-button @click="showdialog2">我要充值</van-button>
            </div>
          </li>

        </ul>

        <div class="t2_btm" v-if="vip.isVip==0">
          成为会员后优惠：<span>￥{{vip.vipAfterDiscount}}</span>
          <br>
          会员权益：{{vip.vipDesc}}
        </div>
      </div>

      <div class="btnline">
        <van-button :class="item.code=='alipay'?'b3':item.code=='wexin'?'b2':'b1'" @click="showConfirm('')" v-for="(item,index) of payList" :key="index">
          <img src="../../../assets/image/zf1.png" v-if="item.code == 'member'"/>
          <img src="../../../assets/image/zf2.png" v-if="item.code == 'wexin'"/>
          <img src="../../../assets/image/zf3.png" v-if="item.code == 'alipay'"/>
            {{item.name}}
        </van-button>
      </div>


    </div>



    <mydialog :show="show1" @cancel="canceldialog" thestyle="top: 30%;">
      <div class="zdycon">
        <div class="title">使用积分</div>
        <div class="item">
          <div class="row displayflex">
            <div class="rl">可用积分:</div>
            <div class="rr"><span>{{memberpointcanuse.pointcanuse}}</span>分</div>
          </div>
          <div class="row displayflex">
            <div class="rl">本次使用:</div>
            <div class="rr">
              <input v-model="usejf" type="number" @blur="handleBlur"/>分
            </div>
          </div>

          <div class="row displayflex">
            <div class="rl">抵扣金额:</div>
            <div class="rr color-yellow">￥{{fentoyuan(memberpointcanuse.amount)}}</div>
          </div>
        </div>
      </div>
    </mydialog>

    <van-popup v-model="show2" position="bottom" style="height:50%" >
      <div class="zdycon">
        <div class="title">
          <span>可使用券列表</span>
          <span class="qd">不使用券</span>
        </div>

        <div class="item">
          <div class="row row2">客人账户共有<span>{{couponList.length}}</span>张优惠券，请选择：</div>
          <div class="row displayflex" v-for="(item,i) of couponList" @click="toggleCoupons(i)">
            <div class="rl2">
              <span>{{item.couponName}}</span>
              <span>{{item.expiredate}}过期</span>
            </div>
            <van-button class="rr2" @click="useCoupon(item)">使用</van-button>
          </div>
        </div>

        <!--<van-button class="jzbtn" @click="submitCoupons">确定使用</van-button>-->

      </div>

    </van-popup>

    <mydialog :show="show3" @cancel="canceldialog" thestyle="top: 30%;">
      <div class="zdycon">
        <div class="title">请选择一种支付方式</div>
        <div class="item item3">
          <van-button class="row3" v-if="wxpay" @click="showdialog5('WXPAY')"><img src="../../../assets/image/zf2.png"/>{{wxpay.payname}}</van-button>
          <van-button class="row3" v-if="alipay" @click="showdialog5('ALIPAY')"><img src="../../../assets/image/zf3.png"/>{{alipay.payname}}</van-button>
          <van-button class="row3" v-if="cashpay" @click="showdialog4"><img src="../../../assets/image/zf1.png"/>{{cashpay.payname}}</van-button>
        </div>

      </div>
    </mydialog>

    <mydialog :show="show4" @cancel="canceldialog4" thestyle="top: 25%;">
      <div class="zdycon">
        <div class="title">现金结账</div>
        <div class="item">
          <div class="row displayflex">
            <div class="rl">应收金额:</div>
            <div class="rr">￥{{fentoyuan(finalpay)}}</div>
          </div>
          <div class="row displayflex">
            <div class="rl">实收金额:</div>
            <div class="rr">
              <span>￥</span>
              <input v-model="shishou" type="number" @blur="handleBlur"/>
              <span class="zh" @click="zhenghao">正好</span>
            </div>
          </div>

          <div class="row displayflex">
            <div class="rl">找零:</div>
            <div class="rr">￥{{zhaoling}}</div>
          </div>
        </div>

        <!--<van-button class="jzbtn" @click="lastestpaybillprintinfo">打印结账单</van-button>-->
        <van-button class="jzbtn" @click="showConfirm('CASHPAY')" >完成结账</van-button>
      </div>
    </mydialog>

    <mydialog :show="show5" @cancel="canceldialog" :icon="remainpaytype=='WXPAY'?'wx':'zfb'" thestyle="top: 35%;">
      <div class="zdycon">
        <div class="zdy1">
          <div>请客人打开付款码调出付款二维码</div>
          <van-button @click="doscan">开始扫描</van-button>
        </div>
      </div>
    </mydialog>

    <mydialog :show="show6" @cancel="canceldialog" thestyle="top: 20%;">
      <div class="zdycon">
        <div class="zdy1" style="margin-bottom: 2rem">
          <div>请客人打开微信扫一扫自助充值</div>
          <!--<vue-qr :text="qrcode" :margin="0" colorLight="#fff"  :logoScale="0.3" :size="160"></vue-qr>-->
        </div>
      </div>
    </mydialog>


  </div>

</template>

<script>
  import { Field,Button,Toast,Dialog,Picker,Popup } from 'vant';
  import Vue from 'vue';
  import http from '../../../service/ServiceHttp';
  import Mydialog from "./Mydialog.vue";
  import Big from 'big.js';
  // import VueQr from "vue-qr";

  Vue.use(Field);
  Vue.use(Dialog).use(Popup).use(Picker);

export default {
  components: {
    Mydialog
  },
  name: 'HelloWorld',
  data () {
    return {
      show1:false,
      show2:false,
      show3:false,
      show4:false,
      show5:false,
      show6:false,

      openstate:true,
      data:{},
      data2:{},
      tableInfo:{},
      memberpointcanuse:{},

      coupons:[],//券列表
      couponChecked:0,//选中的券下标
      couponsItem:{},//选中的券抵扣金额
      jfdk_money:0,//积分抵扣的钱
      yhjdk_money:0,//优惠券抵扣的钱

      usejf:'',//使用的积分
      hypay:0,//会员账户支付
      finalpay:0,//最终支付
      type:false,

      zhaoling:0,
      shishou:0,
      remainpaytype:'',
      dynamicid:'',//支付宝或微信支付的客户动态码

      wx_dynamicid:'', //易石微信码

      wxpay:null,
      alipay:null,
      cashpay:null,
      isuseyue:true,//是否使用余额，默认使用余额
      isnoyue:false,//是否余额不足
      isusejf:false,//是否使用积分，默认不使用
      isuseyhj:false,//是否使用优惠券，默认不使用

      qrcode:'',
      ismanle:false,//是否 抵扣的钱已经满了


      orderAmount:99,//账单金额，单位元
      discount:-8,//账单折扣，负值，单位元
      lastAmount:91,//剩余金额，单位元
      vip:{},//会员信息
      couponList:[],
      payList:[],
      usingCoupon:{},//正在使用的券
    }
  },
  watch:{
    shishou(val){
      val = val.toString();
      if(val.indexOf('.')>0 && val.split('.')[1].length>2){
        this.shishou = Math.floor(parseFloat(val)*100)/100;
        return;
      }

      if(!val){
        this.zhaoling = '';
        return;
      }
      let finalpay = parseFloat(this.fentoyuan(this.finalpay));
      this.zhaoling = new Big(parseFloat(val)).minus(finalpay);
      if(parseFloat(this.zhaoling)<0) this.zhaoling = 0;
      this.shishou = val;
    },
  },

  mounted(){
    //选完优惠券之后又要查一遍吗，但是查的时候为什么不传优惠券相关的参数，还是前端自己算

    this.GetLastAmount();
  },
  methods:{
    GetLastAmount(){
      let params = {outtradeno:''};
      // http.GetLastAmount(params,(res)=>{
      //   let data = res.resultObject;
      //   this.order = data.order; //订单信息
      //   this.couponList = data.couponList;//可用券列表
      //   this.vip = data.vip;//会员信息
      //   this.payList = data.payList; //	支付编码，alipay，wexin，member
      // })

      //订单信息
      this.order = {
        orderAmount:99,//账单金额，单位元
        discount:-8,//账单折扣，负值，单位元
        lastAmount:91,//剩余金额，单位元
      };

      //会员信息
      this.vip = {
        vipRegisterUrl:'',
        rechargeUrl:'',
        balance:998,
        isVip:0,
        vipAfterDiscount:-8,
        vipDesc:'会员权益描述',
      };

      //可用券列表
      this.couponList = [{
        couponid:'',
        couponName:'66元抵用券',
        couponAmount:'66',
        couponImg:'',
      }];

      //可使用的支付方式	支付编码，alipay，wexin，member
      this.payList = [{
        code:'alipay',
        name:'支付宝',
      },{
        code:'wexin',
        name:'微信',
      },{
        code:'member',
        name:'member',
      }];

    },

    useCoupon(item){
      this.usingCoupon = item;
      this.show2 = false;
    },

    // 如果抵扣的钱已经够了，并且积分还没用，那么积分就不用了
    canusejf(){
      if(!this.isusejf && this.finalpay==0 && this.hypay == 0){
        return false;
      }
      return true;
    },
    // 如果抵扣的钱已经够了，并且优惠券还没用，那么优惠券就不用了
    canuseyhj(){
      if(!this.isuseyhj && this.finalpay==0 && this.hypay == 0){
        return false;
      }
      return true;
    },

    pdshownoyue(){ //如果会员支付和还需支付都是0，则不显示 使用不使用余额
      if(this.finalpay==0 && this.hypay == 0){
        return false
      }
      return true
    },
    handleBlur(){
      window.scroll(0,0);
    },

    showdialog5(remainpaytype){
      this.remainpaytype = remainpaytype;
      YumJSSdk.scan((code)=>{
        this.dynamicid = code;
        this.finishpay(remainpaytype)
      });
    },

    doscan(){ //扫描二维码
      this.dynamicid = '';
      this.finishpay(this.remainpaytype);
    },
    zhenghao(){
      this.shishou = this.fentoyuan(this.finalpay);
    },
    reload(){
      this.getwxmember();
    },
    //微信会员
    getwxmember(){
      http.getwxmember(this.wx_dynamicid).then((res)=>{
//        res = {"resultNumber":0,"resultMsg":"","resultObject":{"mcode":"WX156438916909028","accesscode":"oYRH6v9ykrRvmfKf9QfCQN8e_zcU","mname":"李锦涛","company":"","deposit":50000,"giftdeposit":500000,"creditlimit":0,"points":0,"pointsCanUse":0,"birthday":"1980-06-15","birthdaynongli":0,"enabled":1,"secret":"1B2M2Y8AsgTpgAmY7PhCfg==","cardtypecode":"05","cardtypename":"五折","issuedate":"2019-07-29","expiredate":"2039-07-24","expired":0,"endtag":1,"mtypecode":"05","mtypename":"测试会员类","openstoreid":"","iswx":1,"isstorage":0,"gender":0,"basekey":"","synctimeout":0,"inblacklist":0,"depositusetype":1,"depositpaycode":"5102002","giftdepositpaycode":"510159"}}
        if(res.resultNumber == 0){
          this.data = res.resultObject;
          //账户余额=现金卡值+赠送卡值
          this.data.zhye = new Big(this.data.deposit).plus(this.data.giftdeposit);
          if(this.data.zhye<=0){ //余额不足
            this.isnoyue = true;
          }else{ //余额充足
            this.isnoyue = false;
          }
            console.log('data1::,',this.data)
          this.getbillpayinfo(this.data.mcode);
        }else{
          this.$router.go(-1)
        }
      })
    },

    //实体卡
    initEntityCard(){
      this.data = this.$global.entityCardData;
      this.data.zhye = this.data.deposit;
      if(this.data.deposit<=0){ //余额不足
        this.isnoyue = true;
      }else{ //余额充足
        this.isnoyue = false;
      }
      this.getbillpayinfo(this.data.mcode);
    },

    getbillpayinfo(mcode){
      http.getbillpayinfo(mcode,this.$global.tableInfo.billNo).then((res)=>{
          if(res.resultNumber == 0) {
            Toast.clear();
            this.data2 = res.resultObject;
            let coupons = [];
            for(let item of res.resultObject.coupons){
              let obj = item;
              obj.checked = false;
              for(let item2 of item.items){
                obj.couponid = item2.couponid;
                obj.couponamt = item2.couponamt;
                obj.expiredate = item2.expiredate;
                coupons.push(obj)
              }
            }
            this.coupons = coupons;
            this.memberpointcanuse = res.resultObject.memberpointcanuse;
            this.getbillremainamount(()=>{this.useyue()});

          }else{
            this.$router.go(-1)
          }
      })
    },

    //获取账单结账余额信息
    getbillremainamount(callback,onError){
      let couponpayed = {};
      couponpayed.couponid = this.couponsItem.couponid;
      couponpayed.category = this.couponsItem.category;
      if(!this.couponsItem.couponid){
        couponpayed = null;
      }
      let params = {
        "billno":this.data2.billno,
        "mcode":this.data2.mcode,
        "mempayamount":this.hypay,
        "mempointpayamount":this.jfdk_money,
        "mempointuse":this.usejf,
        "couponpayed":[],
        "newcoupon":couponpayed
      }
      Toast.loading({duration:0, forbidClick: true, message:'loading'});
      http.getbillremainamount(params).then((res)=>{
        if(res.resultNumber == 0){
          Toast.clear();
          this.finalpay = res.resultObject.remainamount;
          this.wxpay = res.resultObject.wxpay;
          this.alipay = res.resultObject.alipay;
          this.cashpay = res.resultObject.cashpay;
          this.yhjdk_money = new Big(this.data2.amount).minus(this.data2.discount).minus(this.jfdk_money).minus(this.hypay).minus(this.finalpay);
          if(callback){
            callback();
          }
        }else{
          if(onError){
            onError()
          }
        }
      })
    },

    //获取结账单信息
    lastestpaybillprintinfo(){
      http.lastestpaybillprintinfo(this.data2.billno,this.$store.getters.getuserinfo.uid).then((res)=>{
        if(res.resultNumber == 0){
          Toast.success({duration:1000,message:"操作成功"});
          let lines = JSON.stringify(res.resultObject);
          YumJSSdk.printLinesByTemplate(lines);
        }
      })
    },

    showConfirm(type){
      if(parseFloat(this.shishou) < parseFloat(this.fentoyuan(this.finalpay)) && type=='CASHPAY'){
        Toast.fail({message:"tishi"});
        return;
      }

      Dialog.confirm({title:"提示",message:"tt5"}).then(() => {
        this.finishpay(type);
      }).catch(() => {});
    },

    //结账
    finishpay(remainpaytype){


      let couponpayed = {};
      couponpayed.couponid = this.couponsItem.couponid;
      couponpayed.category = this.couponsItem.category;
      couponpayed = [couponpayed]
      if(!this.couponsItem.couponid){
        couponpayed = null;
      }
      let params = {
        "uid":this.$store.getters.getuserinfo.uid,//操作员
        "ascode":this.$store.getters.getuserinfo.ascode,//密码
        "billno":this.data2.billno,//账单号
        "mcode":this.data2.mcode,
        "mempayamount":this.hypay,//会员现金卡值使用金额(分) **
        "mempointpayamount":this.jfdk_money,//会员积分转赠送卡值使用金额(分) **
        "mempointuse":this.usejf,//会员积分使用值
        "couponpayed":couponpayed,//已使用的券列表
        "remainamount":this.finalpay, //剩余金额(分)
        "moling":0, //抹零金额（分)
        "remainpaytype":remainpaytype,//剩余金额的支付方式：WXPAY：微信支付 ALIPAY：支付宝 CASHPAY：现金 BANKPAY：银行卡
        "bankpaycode":"",//银行卡付款代码
        "dynamicid":this.dynamicid//支付宝或微信支付的客户动态码
      }

      http.finishpay(params).then((res)=>{
        if(res.resultNumber == 0){
          Toast.clear();
          if(res.printData){
            let lines = JSON.stringify(res.printData);
            try {
              YumJSSdk.printCheckTicket(lines);
            }catch (e) {
            }
          }

          //如果支持刷卡就不调用打印结账单接口了
          if(this.$global.banksupport!==0){
            this.canceldialog();
            this.$global.isrefresh = true;//刷新主页数据
            this.$router.replace({path:'main'})
            return;
          }

          Dialog.confirm({title:"提示",message:"tt2",confirmButtonText:"dy",cancelButtonText:"hsy",beforeClose:(action,done)=>{
            if (action === 'confirm') {
              this.lastestpaybillprintinfo();
              done(false);
            } else {
              this.canceldialog();
              this.$global.isrefresh = true;//刷新主页数据
              this.$router.replace({path:'main'})
              done();
            }
          }})
        }
      })
    },

    //计算会员账户支付的钱和最终支付的钱
    set_money(){
      //如果账户余额不足  (账户上的钱少于本次需要支付的钱)，那么就能用多少用多少（）
      if(this.data.zhye < this.finalpay){
        this.hypay = this.data.zhye;
      }else{ //余额充足使用余额
        this.hypay = this.finalpay;
      }
    },

    //不使用余额
    nouesyue(){
      this.hypay = 0;
      this.isuseyue = false;
      this.getbillremainamount();
    },
    //使用余额 (1.余额充足，2余额不足以支付变成差额结账)
    useyue(){
      if(this.finalpay<=0) return;
      this.isuseyue = true;
      //会员账户余额 是否大于本次账单金额，如果大于去账单还需支付的金额，如果小于就取会员账户余额
      this.set_money();
      this.getbillremainamount();
    },


    fentoyuan(num){
      if(!num) return 0;
      return new Big(num).div(100)
    },
    toggleCoupons(i){
      this.couponChecked = i;
    },

    //使用积分
    submitPoints(type){
      this.isusejf = !this.isusejf;
      this.hypay = 0;
      if(type == 1){ //使用积分
        this.usejf = this.memberpointcanuse.pointcanuse;
        this.jfdk_money = this.memberpointcanuse.amount;
        this.getbillremainamount(()=>{this.useyue()},()=>{ //使用积分出错时，改为不使用积分
          this.submitPoints(2);
        });
      }else{ //不使用积分
        this.usejf = 0;
        this.jfdk_money = 0;
        this.getbillremainamount(()=>{this.useyue()});
      }
    },

    //使用优惠券
    submitCoupons(){
      this.isuseyhj = true;
      this.show2 = false;
      this.couponsItem = this.coupons[this.couponChecked];

      // let zdje = this.data2.amount;//账单金额
      // let hyyh = this.data2.discount;//会员优惠
      // let jfdk_money = this.jfdk_money;
      // let yhjdk = this.couponsItem.couponamt || 0;//优惠券抵扣
      // let val = new Big(zdje).minus(hyyh).minus(jfdk_money);
      // val = parseInt(val.toString());
      // if(val<=yhjdk){ //如果优惠券抵扣的钱 比 其它所有优惠过的钱要多，那积分抵扣的钱就显示为 其它所有优惠过的钱
      //   yhjdk = val;
      // }
      // this.yhjdk_money = yhjdk;


      this.hypay = 0;
      this.getbillremainamount(()=>{this.useyue()},()=>{ //如果使用优惠券失败了，改为不使用优惠券
        this.nosubmitCoupons();
      });
    },

    //不使用优惠券
    nosubmitCoupons(){
      this.isuseyhj = false;
      this.couponsItem = {};
      this.couponChecked = 0;
      this.hypay = 0;
      this.getbillremainamount(()=>{this.useyue()});
    },

    routego(){
      this.$router.push({name:'pay'})
    },
    routeback(){
      this.$router.go(-1)
    },

    showdialog2(){

      this.show2 = true;
    },
    showdialog3(){
      this.show3 = true;
    },
    showdialog4(){
      this.show4 = true;
    },
    showdialog6(){
      this.show6 = true;
      if(this.$global.qrcode){
        this.qrcode = this.$global.qrcode;
      }else{
        http.weixinsetupinfo().then((res)=>{
          this.qrcode = res.resultObject.accountUrl;
          this.$global.qrcode = res.resultObject.accountUrl;
        })
      }
    },
    canceldialog(){
      this.show1 = false;
      this.show2 = false;
      this.show3 = false;
      this.show4 = false;
      this.show5 = false;
      this.show6 = false;
      this.dynamicid = '';
    },
    canceldialog4(){
      this.show4 = false;
      this.shishou = 0;
    },
    toggle(){
      this.openstate = !this.openstate
    }
  }
}
</script>

<style scoped lang="scss">
  #pay {
    height: 100%;
    overflow: hidden;
    background: #f1f1f1;

    .con{
      position: absolute;
      top: 0;
      overflow-y: scroll;
      -webkit-overflow-scrolling:touch;    /* 用于 ios5+ */
      bottom: 3rem;
      width: 100%;
    }

    .tabcon2{
      width: 94%;
      margin-left:3%;
      background: #ffffff;
      border-radius: 0.5rem;
      box-shadow: 0 -1px 15px #e2e2e2;
      overflow: hidden;
      margin-top: 1rem;
      margin-bottom: 2rem;
      .t2_tt{
        text-align: center;
        padding:1rem;
        align-items: center;
        border-bottom: 1px solid #e5e5e5;
        span{
          flex:1;
        }
        button{
          background: none;
          border:1px solid #73C172;
          color: #73C172;
          img{
            width: 1.5rem;
            display: inline-block;
            vertical-align: middle;
          }
        }
      }
      .t2_btm{
        text-align: center;
        background: #f7f7f7;
        font-size: 0.8rem;
        padding: 0.5rem;
      }
      ul{
        li{
          padding:0.7rem 0.7rem 0.7rem 0;
          border-bottom: 1px solid #e5e5e5;
          align-items: center;
          font-size: 0.9rem;
          height: 1.5rem;
          .li1{
            width: 34%;
            text-align: right;
            img{
              vertical-align: middle;
              margin-right: 0.5rem;
              display: inline-block;
              width: 1.4rem;
            }
          }
          .li2{
            width: 36%;
            text-align: right;
            span{
              margin: 0 0.2rem;
            }
            .color-gray{
              font-size: 0.8rem;
            }
            p{
              color: #999999;
              font-size: 0.9rem;
              span{
                margin-right: 0.3rem;
                color: #ffffff;
                font-size: 1.1rem;
              }
              .fwfsj{
                margin-left: 0.5rem;
                font-size: 0.9rem;
              }
            }
          }
          .li3{
            width: 30%;
            text-align: right;
            color: #999999;
            .van-button{
              padding:0 0.5rem;
              border-radius: 0.2rem;
              border: 1px solid #c8a970;
              color: #c8a970;
              background: none;
              height: 1.8rem;
              line-height: 1.8rem;
              font-size: 0.8rem;
            }
          }
        }
      }
    }

    .zdycon{
      .zdy1{
        text-align: center;
        p{
          margin: 1rem 0;
          text-align: center;
        }
        button{
          border-radius: 0.3rem;
          background: #DD5333;
          color: #ffffff;
          border: none;
          width: 8rem;
        }
      }
      .title{
        padding: 0.8rem 0.8rem 0 0.8rem;
        .qd{
          color: #449de1;
          font-size: 0.9rem;
          float: right;
        }
      }
      .item{
        margin: 1rem 0;
       .row{
         padding:0.7rem 1rem;
         justify-content: space-between;
         border-bottom: 1px solid #e5e5e5;
         align-items: center;
         &:first-child{
           border-top: 1px solid #e5e5e5;
         }
         &:last-child{
         }
         .rl{
           width:5rem;
           text-align: right;

         }
         .rl2{
           img{
             vertical-align: middle;
             width: 1.4rem;
           }
         }
         .rr2{
           font-size: 0.9rem;
           background: #C1A671;
           border: none;
           color: #fffcf6;
           height: 2rem;
           line-height: 2rem;
         }
         .rr{
           input{
             width: 5rem;
             border: 1px solid #C1A671;
             border-radius: 0.3rem;
             padding:0.3rem 0.5rem;
             color: #fe6000;
             margin-right: 0.3rem;
           }
           span{
             font-size: 1.2rem;
             color: #333333;
             margin-right: 0.3rem;
           }
          .zh{
            display: inline-block;
            color: #ffffff;
            background: #C1A671;
            padding:0.3rem 0.5rem;
            border-radius: 0.3rem;
          }
         }
       }
        .row2{
          background: #f6f6f6;
          font-size: 0.9rem;
          color: #999999;
        }
        .row3{
          text-align: center;
          font-size: 0.9rem;
          width: 90%;
          border-radius: 0.3rem;
          border: none;
          background: #C1A671;
          margin-bottom:0.7rem;
          color: #ffffff;
          margin-left: 5%;

          &:nth-child(1){
            background: #69B82F;
          }
          &:nth-child(2){
            background: #51AAE5;
          }
          img{
            text-align: left;
            width: 1.5rem;
            display: inline-block;
            margin-top: 0.5rem;
            float: left;
          }
        }
      }
      .item3{
        padding-top: 1rem;
        border-top: 1px solid #e5e5e5;
      }

      .jzbtn{
        width: 70%;
        background: #DD5333;
        color: #ffffff;
        border: none;
        margin-left:15%;
        margin-bottom: 1rem;
        border-radius: 0.3rem;

      }
    }

    .btnline{
      width: 94%;
      margin-left: 3%;
      .van-button{
        width: 100%;
        border-radius: 0.2rem;
        color: #FFFFFF;
        margin-bottom: 0.5rem;
        height: 2.6rem;
        line-height: 2.6rem;
        .displayflex{
          align-items: center;
          text-align: center;
        }
        img{
          display: inline-block;
          width: 1.2rem;
          height: 1.2rem;
          margin-right: 0.5rem;
          vertical-align: sub;
          float: left;
          margin-top: 0.65rem;
        }
      }
      .b1{
        background: #e19263;
      }
      .b2{
        background: #2BD971;
      }
      .b3{
        background: #108EE9;
      }
    }
    .displayflex{
      display: flex;
      display: flexbox;
      display: -moz-flex;
      display: -o-flex;
      display: -ms-flex;
      display: -ms-flexbox;
      display: -webkit-box;
      display: -webkit-flex;
    }

    .color-blue{color: #4aafe9 !important;}
    .color-red{color: red !important;}

  }
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->




// WEBPACK FOOTER //
// src/components/routerPages/pay/pay.vue